<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Cobertura por IPT
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Cobertura por IPT</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body align-items-center">
        <div class="col d-flex flex-column" style="max-width: 150px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Detalle</label>
          </div>
        </div>
        <div class="col" style="max-width: 120px">
          <div class="md-form m-0">
            <mdb-select label="Mes" [options]="optionsMonth" formControlName="mes" placeholder="Mes"
              [filterEnabled]="true"></mdb-select>
          </div>
        </div>
        <div class="col" style="max-width: 120px">
          <div class="md-form m-0">
            <mdb-select label="Año" formControlName="anho" [options]="optionsYear" placeholder="Año"
              [filterEnabled]="true"></mdb-select>
          </div>
        </div>

        <div class="col d-flex align-items-center" style="max-width: 650px;">
          <div *ngFor="let item of data; let i = index;">
            <mdb-checkbox [checked]="item.checked" (change)="onChange($event, i, item)">
              {{item.label}}
            </mdb-checkbox>
          </div>
        </div>

        <div class="col d-flex align-items-center" style="max-width: 400px">
          <label class="form-check-label" for="Vendedor">Vendedor Asignado</label>
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarVendedor()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            <span *ngIf="vendedoresSeleccionados.length > 0">{{ vendedoresSeleccionados.length | numerico }}
              Seleccionados</span>
            <span *ngIf="vendedoresSeleccionados.length == 0">{{ vendedorSeleccionado?.nombre }}</span>
          </h6>
        </div>

        <div class="col d-flex align-items-center" style="max-width: 350px;">
          <div class="form-check">
            <mdb-checkbox [checked]="false" formControlName="ActivarCliente" (change)="onChangeCliente($event)">
              Incluir Clientes Desactivados
            </mdb-checkbox>
          </div>
          <div>
            <mdb-checkbox formControlName="producto_sin_sku">Incluir producto sin SKU</mdb-checkbox>
          </div>
        </div>
      </div>
      <div class="row filtros-body align-items-center" style="max-width: 350px; padding-left: 25px;">
        <div class="col d-flex flex-column" style="max-width: 200px;">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaRubro"></mdb-select>
            <label>Rubro</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer  justify-content-end" style="border-top: 1px solid #dee2e6">
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>
</form>

<!--VISTA DETALLE -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div *ngIf="resumen_loading && detalle_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="resumen_loading || detalle_loading" spinnerColor="blue"></mdb-spinner>
    </div>

    <div *ngIf="!resumen_loading && resumen_listaMovimientos">
      <!-- VISTA RESUMEN -->
      <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
        <div *ngIf="resumen_listaMovimientos">
          <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Detalle</th>
                <th scope="col" class="text-center">Total Cliente</th>
                <th scope="col" class="text-center">Cliente (Con Pedido)</th>
                <th scope="col" class="text-center">Total Pedidos</th>
                <th scope="col" class="text-right">Total Ventas</th>
                <th scope="col" class="text-right">% Cobertura (Ventas)</th>
                <th scope="col" class="text-right">% Cobertura (Clientes)</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let res of resumen_listaMovimientos">
                <td>{{res.vendedor_codigo}}</td>
                <td>{{res.vendedor_nombre}}</td>
                <td class="text-center">{{res.total_cliente_vendedor | numerico}}</td>
                <td class="text-center">{{res.clientesConPedidos | numerico}}</td>
                <td class="text-center">{{res.numero_pedido | numerico}}</td>
                <td class="text-right">{{res.total_neto | numerico }}</td>
                <td class="text-right">{{res.coberturaVentas}}</td>
                <td class="text-right">{{res.coberturaClientes}}</td>

              </tr>
            </tbody>

          </table>

          <div class="table-responsive mt-3">
            <table class="table table-striped table-hover table-sm align-middle">
              <tbody class="blue lighten-5">
                <tr>
                  <td>TOTALES</td>
                  <td scope="col">
                    <span style="font-weight: bold; font-size: 15px;">Clientes: </span>
                    <span>{{resumen_totales.cantidadClientesResumen | numerico}}</span>
                  </td>
                  <td scope="col">
                    <span style="font-weight: bold; font-size: 15px;">Clientes(Con pedidos): </span>
                    <span>{{resumen_totales.cantidadClientesPedidoResumen | numerico}}</span>
                  </td>
                  <td scope="col">
                    <span style="font-weight: bold; font-size: 15px;">Pedidos: </span>
                    <span>{{resumen_totales.totalPedidosResumen | numerico}}</span>
                  </td>
                  <td scope="col">
                    <span style="font-weight: bold; font-size: 15px;">Ventas: </span>
                    <span>{{resumen_totales.TotalVentaResumen | numerico}}</span>
                  </td>

              </tbody>
            </table>
          </div>
          <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)">
          </app-pagination>
        </div>
      </div>
    </div>

    <div *ngIf="!detalle_loading && detalle_listaMovimientos">
      <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
        <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">RUT</th>
              <th scope="col">Cliente</th>
              <th scope="col" class="">Secuencia</th>
              <th scope="col" class="">Sucursal</th>
              <th scope="col">Dirección.</th>
              <th scope="col" class="">Comuna</th>
              <th scope="col" class="">Vendedor</th>
              <th scope="col" class="text-center">Estado</th>
              <th scope="col">L</th>
              <th scope="col">M</th>
              <th scope="col">Mi</th>
              <th scope="col">J</th>
              <th scope="col">V</th>
              <th scope="col">S</th>
              <th scope="col">D</th>
              <th scope="col" class="text-center">N°Ped.</th>
              <th scope="col" class="text-right">Venta</th>
              <th scope="col">Fec.Ult.Com.</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!detalle_loading && detalle_listaMovimientos?.length === 0">
              <td colspan="100%" style="text-align: center">
                No se encontró información
              </td>
            </tr>
            <tr *ngFor="let data of detalle_listaMovimientos">
              <td scope="col">{{data.rutFormato | rut}}</td>
              <td scope="col">{{data.cliente_nombre}}</td>
              <td scope="col">{{data.secuencia}}</td>
              <td scope="col" class="">{{data.codsuclegacy}}</td>
              <td scope="col">{{data.direccion_completa}}</td>
              <td scope="col" class="">{{data.comuna}}</td>
              <td scope="col" class="">{{data.vendedor_codigo}}</td>
              <td scope="col" class="text-center">
                <mdb-badge pill="true" success="true" *ngIf='data.activo == true'>{{data.estado_cliente}}</mdb-badge>
                <mdb-badge pill="true" danger="true" *ngIf='data.activo == false'>{{data.estado_cliente}}</mdb-badge>
              </td>
              <td scope="col">
                <mdb-icon *ngIf="data.lunes == true" far icon="check-square"></mdb-icon>
                <mdb-icon *ngIf="data.lunes == false" far icon="square"></mdb-icon>
              </td>
              <td scope="col">
                <mdb-icon *ngIf="data.martes == true" far icon="check-square"></mdb-icon>
                <mdb-icon *ngIf="data.martes == false" far icon="square"></mdb-icon>
              </td>
              <td scope="col">
                <mdb-icon *ngIf="data.miercoles == true" far icon="check-square"></mdb-icon>
                <mdb-icon *ngIf="data.miercoles == false" far icon="square"></mdb-icon>
              </td>
              <td scope="col">
                <mdb-icon *ngIf="data.jueves == true" far icon="check-square"></mdb-icon>
                <mdb-icon *ngIf="data.jueves == false" far icon="square"></mdb-icon>
              </td>
              <td scope="col">
                <mdb-icon *ngIf="data.viernes == true" far icon="check-square"></mdb-icon>
                <mdb-icon *ngIf="data.viernes == false" far icon="square"></mdb-icon>
              </td>
              <td scope="col">
                <mdb-icon *ngIf="data.sabado == true" far icon="check-square"></mdb-icon>
                <mdb-icon *ngIf="data.sabado == false" far icon="square"></mdb-icon>
              </td>
              <td scope="col">
                <mdb-icon *ngIf="data.domingo == true" far icon="check-square"></mdb-icon>
                <mdb-icon *ngIf="data.domingo == false" far icon="square"></mdb-icon>
              </td>
              <td scope="col" class="text-center">
                <span *ngIf="data.numero_pedido > 0">{{data.numero_pedido | numerico}}</span>
              </td>
              <td scope="col" class="text-right">
                <span *ngIf="data.total_neto != 0">{{data.total_neto | numerico}}</span>
              </td>
              <td scope="col">{{data.fecha_emision | fecha}}</td>
            </tr>
          </tbody>
        </table>

        <div class="table-responsive mt-3" *ngIf="detalle_listaMovimientos">
          <table class="table table-striped table-hover table-sm align-middle">
            <tbody class="blue lighten-5">
              <tr>
                <td colspan="11">TOTALES</td>
                <td scope="col">
                  <span style="font-weight: bold; font-size: 15px;">Clientes: </span>
                  <span>{{detalle_totales.cantidadClientes | numerico}}</span>
                </td>
                <td scope="col">
                  <span style="font-weight: bold; font-size: 15px;">Clientes(Con pedidos): </span>
                  <span>{{detalle_totales.cantidadClientesPedido | numerico}}</span>
                </td>
                <td scope="col">
                  <span style="font-weight: bold; font-size: 15px;">Pedidos: </span>
                  <span>{{detalle_totales.totalPedidos | numerico}}</span>
                </td>
                <td scope="col">
                  <span style="font-weight: bold; font-size: 15px;">Ventas: </span>
                  <span>{{detalle_totales.TotalVenta | numerico}}</span>
                </td>
                <td scope="col">
                  <span style="font-weight: bold; font-size: 15px;">% Cobertura (Pedidos): </span>
                  <span>{{detalle_totales.totalCoberturaPedido}}</span>
                </td>
                <td scope="col">
                  <span style="font-weight: bold; font-size: 15px;">% Cobertura (Clientes): </span>
                  <span>{{detalle_totales.totalCoberturaCliente}}</span>
                </td>
            </tbody>
          </table>
          <app-pagination [context]="detalle_paginationContext"
            (onPageChange)="detalleOnPageChange($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn size="sm" type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="resumenDownloadExcelPdf('XLS')">Excel</button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"
      (click)="detalleDownloadExcelPdf('XLS')">Excel</button>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<app-seleccionar-vendedor [multiple]="TIPO_VISTA" queryType="VENDEDOR"
  (onSelectMultiple)="onVendedorSeleccionadoMultiple($event)" (onSelectSingle)="onVendedorSeleccionado($event)"
  (onNotFound)="onVendedorNoEncontrado()">
</app-seleccionar-vendedor>
